const BUILDING_FIELD_CANDIDATES = [
  'building', 'Building', 'U_Building', 'U_BuildingNum', 'buildingNum', 'בניין',
];

const APARTMENT_FIELD_CANDIDATES = [
  'apartment', 'Apartment', 'aprt', 'Aprt', 'U_Aprt', 'U_Apartment', 'דירה',
];

const normalizeCellText = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

const findColumnByLabel = (columns, pattern) =>
  (columns || []).find((col) => pattern.test(String(col.label || col.field || '')));

const pickValueFromRow = (row, fieldNames) => {
  for (const field of fieldNames) {
    const value = normalizeCellText(row?.[field]);
    if (value) return value;
  }
  return '';
};

export const extractTenantLocationFilter = (row, columns = []) => {
  const buildingCol = findColumnByLabel(columns, /בניין/i);
  const apartmentCol = findColumnByLabel(columns, /דירה/i);

  const building = buildingCol
    ? normalizeCellText(row[buildingCol.field])
    : pickValueFromRow(row, BUILDING_FIELD_CANDIDATES);

  const apartment = apartmentCol
    ? normalizeCellText(row[apartmentCol.field])
    : pickValueFromRow(row, APARTMENT_FIELD_CANDIDATES);

  return { building, apartment };
};

export const isTenantDocumentsActionColumn = (col) => {
  const label = String(col?.label || '').trim();
  if (/פירוט|מסמכים|פרטים/i.test(label)) return true;
  if (label === '+' || label === '＋') return true;
  if (col?.type === 'action' || col?.type === 'icon' || col?.type === 'button') return true;
  if (col?.type === 'link' && /פירוט|\+|מסמכים|פרטים/i.test(label)) return true;
  return false;
};

export const buildDocumentsPrefilterFilters = (columns, { building, apartment }) => {
  const filters = {};
  const buildingCol = findColumnByLabel(columns, /בניין/i)
    || columns.find((col) => BUILDING_FIELD_CANDIDATES.includes(col.field));
  const apartmentCol = findColumnByLabel(columns, /דירה/i)
    || columns.find((col) => APARTMENT_FIELD_CANDIDATES.includes(col.field));

  if (buildingCol && building) {
    filters[buildingCol.field] = { select: [building] };
  }
  if (apartmentCol && apartment) {
    filters[apartmentCol.field] = { select: [apartment] };
  }

  return filters;
};

export const formatTenantLocationLabel = ({ building, apartment }) => {
  const parts = [];
  if (building) parts.push(`בניין ${building}`);
  if (apartment) parts.push(`דירה ${apartment}`);
  return parts.join(', ');
};
